import React from "react";
import SectionTitle from "../../SectionTitle";
import Container from "../../Layout/Container";

const ListBox = ({ data, addContainer = false, className }) => {
  const { title, lists } = data || {};

  if (!title || !lists?.length) return null;

  const Component = addContainer ? Container : React.Fragment;
  const props = addContainer ? { className } : {};

  return (
    <Component {...props}>
      {title && (
        <SectionTitle
          title={title}
          color={"secondary"}
          weight="bold"
          className={"mb-8 text-center"}
        />
      )}

      {lists?.length > 0 && (
        <div className="mx-auto grid w-full max-w-[1024px] grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {lists?.map((item, index) => (
            <div key={index} className="bg-[#f9f9f9] p-7">
              <h3 className="mb-3 font-openSans text-2xl text-black">
                {item?.heading}
              </h3>

              <div
                className="page-content font-openSans text-xl text-black"
                dangerouslySetInnerHTML={{ __html: item?.content }}
              ></div>
            </div>
          ))}
        </div>
      )}
    </Component>
  );
};

export default ListBox;
